import { render, staticRenderFns } from "./cont.vue?vue&type=template&id=1241b67c&scoped=true"
import script from "./cont.vue?vue&type=script&lang=js"
export * from "./cont.vue?vue&type=script&lang=js"
import style0 from "./cont.vue?vue&type=style&index=0&id=1241b67c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1241b67c",
  null
  
)

export default component.exports